import { render } from "./SSO.vue?vue&type=template&id=d58751ec"
import script from "./SSO.vue?vue&type=script&lang=js"
export * from "./SSO.vue?vue&type=script&lang=js"

import "./SSO.vue?vue&type=style&index=0&id=d58751ec&lang=scss"

import exportComponent from "/app/tmp/downer/V3/v2025.50.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__